import constants from "../constants";
import { IHashMap, IModifiedType } from "../sync/sync.types";
import idSerializer from "geotab-uuid";

export interface IGroup {
    name?: string;
    id: string;
}

export interface IGroupLinkedDevice extends IHashMap<IGroupLinkedDevice> {
    from: string;
    to: string;
    group: IGroup;
    linkedEntity: IIdEntity;
}

export default class GroupLinkedDevice implements IGroupLinkedDevice {
    id: string;
    from: string;
    to: string;
    group: IGroup;
    linkedEntity: IIdEntity;

    modified?: IModifiedType;
    previousState?: IGroupLinkedDevice;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter?: number;

    constructor(obj: DeepReadonly<IGroupLinkedDevice>) {
        this.id = obj.id || idSerializer.get();
        this.from = obj.from;
        this.to = obj.to || constants.MAX_DATE.toISOString();
        this.group = obj.group || {};
        this.linkedEntity = obj.linkedEntity || {};

        this.modified = obj.modified;
        this.previousState = obj.previousState;
        this._syncCounter = obj._syncCounter || 5;
    }
}